import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import { useScript } from '../../../../hooks/use-script';
import Global from '../../../../store/global-selectors';
import { SQUARE_BILLING_PROVIDER_ID } from '../constants';
import { UPS_CTP_BILLING_PLAN_IDS, UPS_DC_BILLING_PLAN_IDS } from '../../../../enums/billing-plan-ids';
import { useGlobalModalLaunchContext } from '../../../../contexts/modal-context/global-modal-context';
import { UserPermissionService } from '../../../../services/user-permission-service';

export const ChangeBillingInfoButton = React.forwardRef(
  ({ children, className = '', theme = '', onClickTrack = noop, onConfirmClickTrack = noop }, ref) => {
    const userHasAccountManagementRole = useSelector((state) => {
      const userRoles = Global.selectUseruserRoles(state);
      return UserPermissionService.userHasAccountManagementRole(userRoles);
    });
    const { openBillingInfoModal: openBillingInfoModalSingleFlow } = useGlobalModalLaunchContext();

    const planInfo = useSelector(Global.selectSellerPlanInfo);
    const { plan: { billingPlanId = '' } = {}, billingProviderID } = planInfo;
    const canModifyBillingInfo =
      userHasAccountManagementRole &&
      billingProviderID !== SQUARE_BILLING_PROVIDER_ID &&
      ![...UPS_CTP_BILLING_PLAN_IDS, ...UPS_DC_BILLING_PLAN_IDS].some((id) => id === parseInt(billingPlanId, 10));

    const openBillingInfoModal = useCallback(() => {
      onClickTrack();
      openBillingInfoModalSingleFlow({ trackConfirmClick: onConfirmClickTrack });
    }, [onClickTrack, onConfirmClickTrack, openBillingInfoModalSingleFlow]);
    useScript('https://js.recurly.com/v4/recurly.js', ref);

    if (!canModifyBillingInfo) {
      return null;
    }

    return (
      <>
        <Button className={className} onClick={openBillingInfoModal} theme={theme}>
          {children}
        </Button>
      </>
    );
  },
);

ChangeBillingInfoButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  theme: PropTypes.string,
  onClickTrack: PropTypes.func,
};

export default ChangeBillingInfoButton;
